// © 2026 Orpyx Medical Technologies Inc.

import {FormikBag} from "formik";
import {PatientSubmitCareNoteFormProps, PatientSubmitCareNoteFormValues} from "./patient-submit-care-note-form.interface";
import {TimeSpan} from "../../../../../../shared/utility/timeSpan";

// Used by patient care note Formik form
export const onSubmitPatientSubmitCareNoteForm = (values: PatientSubmitCareNoteFormValues, bag: FormikBag<PatientSubmitCareNoteFormProps, PatientSubmitCareNoteFormValues>) => {
    bag.props.onSubmit({
        comment: values.comment,
        actionId: parseInt(values.actionId, 10),
        primaryConcernId: values.primaryConcernId ? parseInt(values.primaryConcernId, 10) : undefined,
        suggestedActionId: values.suggestedActionId ? parseInt(values.suggestedActionId, 10) : undefined,
        timeSpent: values.overrideTime ? TimeSpan.fromHoursAndMinutesAndSecondsToSeconds(values.timeSpent) : undefined,
    });
};